import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/legalBilling/legalBilling.setInvoiced.mutation.gql"
import { LEGAL_BILLING_REFETCH_QUERIES } from "@/v2-backoffice-client/legalBilling/legalBilling.query"
import type {
  LegalBillingSetInvoicedMutation,
  LegalBillingSetInvoicedMutationVariables,
} from "@/v2-backoffice-client/legalBilling/__types__/legalBilling.setInvoiced.mutation"

type Options = MutationHookOptions<
  LegalBillingSetInvoicedMutation,
  LegalBillingSetInvoicedMutationVariables
>

// useLegalBillingSetInvoicedMutation marks or unmarks a set of purchase rows as invoiced.
//
// Always refetches the range rather than patching the cache: one mark moves the invoiced
// rollup at the batch, tag, tenant and range levels simultaneously, and a hand-written
// cache update that gets one of those wrong shows the admin a total that does not match
// what they just billed. `awaitRefetchQueries` so the button's loading state covers the
// refetch — a group that visibly re-renders after the spinner stops reads as a second,
// unexplained change.
export function useLegalBillingSetInvoicedMutation(options?: Options) {
  return useMutation<
    LegalBillingSetInvoicedMutation,
    LegalBillingSetInvoicedMutationVariables
  >(mutation, {
    refetchQueries: [...LEGAL_BILLING_REFETCH_QUERIES],
    awaitRefetchQueries: true,
    ...options,
  })
}
